import React from 'react';
import { ModalConfirm } from '../../components/common/ModalConfirm';
import { Translate as t } from '../../config/Translate';

// FEAT-063 (#621): 이메일 로그인 전환기 안내.
// 로그인 식별자가 ID → 이메일로 바뀌기 전(FEAT-053 #501) 당분간은 ID·이메일 둘 다 로그인된다.
// ID 로 로그인에 성공한 사용자에게만 본인 이메일을 보여주고 이메일로 로그인해 달라고 안내한다.

const normalize = (v) => (typeof v === 'string' ? v.trim().toLowerCase() : '');

// 로그인 입력값이 계정 이메일과 다르면 ID 로그인으로 본다(대소문자·앞뒤 공백 무시).
// 계정에 이메일이 없으면 안내할 대상이 없으므로 띄우지 않는다.
export const shouldShowLoginEmailNotice = (loginInput, user) => {
    const email = normalize(user?.email);
    const input = normalize(loginInput);
    if (!email || !input) return false;
    return input !== email;
};

// 버튼은 [확인] 하나다. 닫기·ESC·배경 클릭도 모두 onClose — 안내일 뿐 막는 단계가 아니다.
const LoginEmailNoticeModal = ({ show, email, onClose }) => (
    <ModalConfirm
        closeLabel={t('common.button.confirm')}
        callbackClose={onClose}
        info={{
            showModal: !!show,
            title: t('auth.message.info.loginEmailNoticeTitle'),
            actions: [],
            content: (
                <div className="rg-login-email-notice">
                    <p>{t('auth.message.info.loginEmailNoticeChange')}</p>
                    <p style={{ marginBottom: 4 }}>{t('auth.message.info.loginEmailNoticeYourEmail')}</p>
                    <p style={{ fontWeight: 700, fontSize: '1.1em', wordBreak: 'break-all' }} data-testid="login-email-notice-email">
                        {email ?? ''}
                    </p>
                    <p>{t('auth.message.info.loginEmailNoticeRequest')}</p>
                    <p style={{ marginBottom: 0 }}>{t('auth.message.info.loginEmailNoticeTransition')}</p>
                </div>
            ),
        }} />
);

export default LoginEmailNoticeModal;
